import Equifax from "../../assets/company-logos/Equifax.png";
import DataAxle from "../../assets/company-logos/dataaxle.png";
import Experian from "../../assets/company-logos/Experian.png";
import HazardHub from "../../assets/company-logos/HazardHub.png";
import Attom from "../../assets/company-logos/Attom.png";
import Quantarium from "../../assets/company-logos/Quantarium.png";
import Precisely from "../../assets/company-logos/Precisely.png";
import Acxiom from "../../assets/company-logos/Acxiom.png";
import Infutor from "../../assets/company-logos/Infutor.png";
import IHSMarkit from "../../assets/company-logos/IHSMarkit.png";

const data = {
  usecaseInfo: {
    name: "Optimize Application Prefill",
    description:
      "A single platform for prefilling data pertaining to people, places, and businesses, globally.",
    button: {
      text: "Download Solution Brief",
      url: "/demyst_ap.pdf",
      download: true,
    },
  },
  recipesInfo: {
    title: "Reduce application dropoff",
    description:
      "Access API-ready solutions for business firmographics, business credit, property characteristics, personal details, and vehicle characteristics, among many others.",
  },
  recipes: [
    {
      type: "Business Data",
      title: "Business Firmographics",
      description:
        "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details.",
    },
    {
      type: "Business Data",
      title: "US Business Operating Hours",
      description: "Gather the operating hours of a business for business insurance prefill",
    },
    {
      type: "Business Data",
      title: "Business Prefill Growth Indicators",
      description: "Gather key information about a business for business insurance prefill",
    },
    {
      type: "People Data",
      title: "US Person Address From Name and Phone",
      description: "Based on name, phone, and country, prefill a person's address",
    },
    {
      type: "Business Data",
      title: "US Property Risk",
      description:
        "Gather small business and commercial property risk data for business or commercial property insurance pre-fill",
    },
    {
      type: "Business Data",
      title: "Property Ownership and Occupancy",
      description:
        "Gather property occupancy and risk data, and owner characteristics for residential property insurance pre-fill",
    },
    {
      type: "People Data",
      title: "Personal Auto Screening",
      description: "Gather basic auto risks from individuals for personal auto insurance pre-fill",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],
  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "DataAxle",
        img: DataAxle,
      },
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "HazardHub",
        img: HazardHub,
      },
      {
        name: "Attom",
        img: Attom,
      },
      {
        name: "Quantarium",
        img: Quantarium,
      },
      {
        name: "Precisely",
        img: Precisely,
      },
      {
        name: "Acxiom",
        img: Acxiom,
      },
      {
        name: "Infutor",
        img: Infutor,
      },
      {
        name: "IHSMarkit",
        img: IHSMarkit,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Residential Property Data For Marketing Decisions",
      url: "https://demyst.com/blog/residential-property-data-improves-marketing-decisions",
      featured_image: "https://cdn.buttercms.com/d9kXSLsS46refWzF1wQ9",
      date: "2021-10-22",
      description:
        "Tax assessor data provides a wealth of information, including property ownership, assessed value, and property characteristics (e.g., number of floors, presence of a fireplace). However, it suffers from three major issues:",
      more: "",
    },
    {
      title: "External Data Insights for the Insurance Industry",
      url: "https://demyst.com/blog/external-data-insights-for-the-insurance-industry",
      featured_image: "https://cdn.buttercms.com/B6gv9H7MRfalVopxeDFI",
      date: "2021-10-15",
      description:
        "The insurance industry is undergoing a deep transformation. The global pandemic, the risks posed by climate change, and the acceleration of digitization have disrupted the industry’s standard business processes. At the same time, increasing numbers of new data products are providing more detailed insights and better predictive capabilities that improve business decisions.",
      more: "",
    },
    {
      title: "Automating Due Diligence Processes with Business Website Lookup",
      url: "https://demyst.com/blog/automating-due-diligence-processes-with-business-website-lookup",
      featured_image: "https://cdn.buttercms.com/xoTPr1u3QjmFI0qjwfGm",
      date: "2021-10-07",
      description:
        "Approximately 28% of businesses in the United States still lack a website, but the vast majority of them have websites providing basic information such as an official business name, business address, business phone, and contact information. Businesses that do not have a website are under significant pressure to build one given remote working requirements and the transition to e-commerce.",
      more: "",
    },
  ],
};

export default data;
